import styled, { keyframes } from 'styled-components';
import { COLOR } from '../../../assets/constants/constants'

const { quaternary, secondary } = COLOR;

const fadeIn = keyframes`
  0% { opacity: 0 }
  100% { opacity: 1 }
`

export const Wrapper = styled.div`
  width: 100%;
  height: calc(56px${p => p.height ? `+ ${p.height}px` : ''});
  transition: all .3s ease-out;

  @media (min-width: 768px) and (max-height: 700px){
    height: calc(48px${p => p.height ? `+ ${p.height}px` : ''});
  }

  &.divisor {
    border-bottom: #eceded solid 1px;
    margin-top: 12px;
    @media (min-width: 768px) and (max-height: 700px){
      margin-top: 6px;
    }
    &.active {
      border-bottom: #aedbd9 solid 2px;
      div{
        color: #aedbd9;
      }
    }
  }

  &.subtitled {
    height: 65px !important;
  }

  &.active {
    p, div {
      color: #aedbd9;
    }
    
  }
`

export const Subtitle = styled.p`
 font-family: 'Amorim Sans Serif';
  text-transform: uppercase;
  margin-bottom: 0;
  margin-top: -8px;
  font-weight: bold;
  letter-spacing: 1.6px;
  font-size: 12px;
`
export const Button = styled.div`
  width: 100%;
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  @media (min-width: 768px) and (max-height: 700px){
    min-height: 48px;
  }

  svg {
    width: 20px;
    height: 20px;
    opacity: 0;
    transition: all .3s ease-out;
    animation: ${fadeIn} .7s ease-out forwards;
  }

  &:hover {
    p, div {
      color: #aedbd9;
    }

    svg {
      color: #aedbd9;
    }
  }
`

export const TitleWrapper = styled.div`
  font-family: 'Amorim Sans Serif';
  font-size: 18px;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 1px;
  line-height: 26px;
  color: ${secondary};
  margin-bottom: 0;
  transition: all .3s ease-out;

  @media (min-width: 768px) and (max-height: 700px){
    font-size: 14px;
  }
`

export const SubMenu = styled.ul`
  width: 100%;
  height: auto;
  
  transition: all .3s ease-out;
  list-style: none;
`

export const SubMenuButton = styled.li`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  cursor: pointer;
  padding: 6px 0 ;
  font-family: 'Amorim Sans Book';
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: .6px;
  color: ${secondary};
  transition: all .3s ease-out;
  margin-bottom: .4rem;
  opacity: 0;
  animation: ${fadeIn} .7s ease-out forwards ${p => p.delay}s;

  &.active {
    color: ${quaternary};
    &:after {
      background: ${quaternary};
      transform: scaleY(2);
    }
  }
  
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 1px;
    transform-origin: center;
    background: ${secondary};
    transition: all .3s ease-out;
  }

  &:hover {
    color: ${quaternary};
  }
`